"use client";

import { Sparkles } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/catalyst/button";
import { useState, useEffect } from "react";
import { Markdown } from "@/components/content/markdown";

export default function AISummary({ summary }) {
  // Add a mounted state to track hydration
  const [mounted, setMounted] = useState(false);

  // Set mounted flag after hydration is complete
  useEffect(() => {
    setMounted(true);
  }, []);

  // For server-rendering, return a simpler version without the popover
  if (!mounted) {
    return (
      <Button outline>
        <Sparkles size={16} />
        AI summary
      </Button>
    );
  }

  // Client-side only rendering after hydration
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button outline>
          <Sparkles size={16} />
          AI summary
        </Button>
      </PopoverTrigger>
      <PopoverContent className="max-h-[60vh] w-96 max-w-full overflow-y-auto rounded-2xl p-4 sm:max-h-[80vh]">
        <div className="flex items-center bg-linear-to-tr from-purple-600 to-cyan-500 bg-clip-text pb-2 font-mono text-sm text-transparent dark:from-purple-400 dark:to-cyan-400">
          <div className="mr-2 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-linear-to-tr from-purple-500 to-cyan-500">
            <Sparkles className="size-4 text-white" />
          </div>
          <span className="font-bold">AI-assisted summary</span>
        </div>
        <Markdown content={summary} balance />
      </PopoverContent>
    </Popover>
  );
}
